import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import  ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function BloombergBusinessweekCover({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  return (
  <div className="wrapper">
 	 <div className="inner-wrapper">

	<Helmet>
		<meta charSet="utf-8" />
		<title>Maria Chimishkyan — {ProjectModel.BloombergBusinessweekCover.title}</title>
	</Helmet>

	<Container fluid className="page-pad">
		<Row>
			<Col sm={3}>
				<div className="description-sticky">
				  <ProjectDescription projectModel={ProjectModel.BloombergBusinessweekCover}/>
				  <ProjectDescription projectModel={ProjectModel.BloombergBusinessweekFeature}/>
				</div>
			</Col>
			<Col sm={6}>
				<img src="img/project-page/bloomberg-businessweek-cover/bloomberg-businessweek-cover-MariaChimishkyan-1.jpg" alt="Bloomberg Businessweek Cover — Maria Chimishkyan 1" style={{ width: '100%' }}/>
				<div style={{ marginTop: '100px' }}>
					<img src="img/project-page/bloomberg-businessweek-cover/bloomberg-businessweek-cover-MariaChimishkyan-2.jpg" alt="Bloomberg Businessweek Cover — Maria Chimishkyan 2" style={{ width: '100%' }}/>
				</div>
			</Col>
		</Row>
	</Container>
	</div>
	<ProjectIndex/>
</div>

  )
}

export default connect()(BloombergBusinessweekCover);
